// extracted by mini-css-extract-plugin
module.exports = {"bkg":"Loading_bkg__8I53V","loadingGif":"Loading_loadingGif__2-CzD","loading":"Loading_loading__2_SqS"};